import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Image as ImageIcon, FolderKanban, Users, Newspaper, Briefcase, Inbox, LogOut, Home, ClipboardList, Settings, GraduationCap, ListChecks, Building, MessageSquareQuote } from "lucide-react";
import { GESIL_LOGO_URL } from "../../data/content";

const ITEMS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/hero-slides", label: "Hero Slides", icon: ImageIcon },
  { to: "/admin/projects", label: "Projects", icon: FolderKanban },
  { to: "/admin/content", label: "Services & AI & Expertise", icon: ListChecks },
  { to: "/admin/leaders", label: "Leadership", icon: Users },
  { to: "/admin/clients", label: "Clients", icon: Building },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { to: "/admin/blogs", label: "Blogs", icon: Newspaper },
  { to: "/admin/careers", label: "Careers", icon: Briefcase },
  { to: "/admin/internships", label: "Internships", icon: GraduationCap },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
  { to: "/admin/audit-log", label: "Audit Log", icon: ClipboardList },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#F6F9FF] flex">
      <aside className="w-72 shrink-0 bg-white border-r border-blue-100 p-6 flex flex-col sticky top-0 h-screen">
        <Link to="/" className="block mb-8">
          <img src={GESIL_LOGO_URL} alt="GESIL" className="h-16 w-auto object-contain" />
        </Link>

        <nav className="mt-10 space-y-1">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-[#2563EB] text-white shadow-[0_12px_24px_-12px_rgba(37,99,235,0.6)]"
                      : "text-[#475569] hover:bg-blue-50 hover:text-[#2563EB]"
                  }`
                }
              >
                <Icon size={16} /> {it.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="mt-auto space-y-3 pt-6 border-t border-blue-100">
          <Link to="/" className="flex items-center gap-2 text-xs text-[#475569] hover:text-[#2563EB]">
            <Home size={14} /> View website
          </Link>
          <div className="text-xs text-[#475569]">Signed in as</div>
          <div className="text-sm font-medium text-[#0F172A]">{user?.email}</div>
          <button onClick={onLogout} data-testid="admin-logout" className="w-full inline-flex items-center justify-center gap-2 rounded-md border border-blue-200 hover:border-[#2563EB] hover:text-[#2563EB] text-[#0F172A] py-2.5 text-sm font-semibold">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 p-8 md:p-12 max-w-full overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
